import AffiliatePortalView from "../AffiliatePortalView";

export default [
  {
    path: "/affiliate",
    component: AffiliatePortalView,
    children: [
      {
        path: "",
        name: "AffiliateDashboard",
        component: () => import("../Pages/DashboardPage"),
        meta: { requiresAffiliate: true },
      },
      {
        path: "rides",
        name: "AffiliateRides",
        component: () => import("../Pages/RidesPage"),
        meta: { requiresAffiliate: true },
      },
      {
        path: "password",
        name: "AffiliatePassword",
        component: () => import("../Pages/PasswordPage"),
        meta: { requiresAffiliate: true },
      },
    ],
  },
];
